import { normalizeListFilters } from './filterDateUtils';

/**
 * وضعیت لیست (فیلترها و ...) فقط هنگام بازگشت از جزئیات/ویرایش بازیابی می‌شود.
 * از sessionStorage استفاده نمی‌شود تا با تغییر منو، فیلترهای قبلی برنگردند.
 */
export const captureListState = (state) => {
  if (!state) return null;
  return {
    ...state,
    filters: state.filters ? normalizeListFilters(state.filters) : state.filters,
  };
};

export const LIST_RESTORE_STATE_KEY = 'restoreListState';

/** ساخت state ناوبری به جزئیات (سازگار با Leads/Deals و صفحات جدید) */
export const buildDetailNavigationState = (listSnapshot, returnTo, extra = {}) => ({
  [LIST_RESTORE_STATE_KEY]: listSnapshot,
  listState: listSnapshot,
  returnTo,
  ...extra,
});
